var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user)?_c('p',{staticClass:"text-center"},[_vm._v(" Already have an account? "),_c('router-link',{class:_vm.$vuetify.theme.dark ? 'white--text' : 'black--text',attrs:{"to":"/sign-in"}},[_vm._v("Sign In")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }